import { Paper, Grid, Link, Typography, Box, Button } from "@mui/material"
import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { isMobile } from "react-device-detect";
import { Link as RouterLink, useParams } from "react-router-dom";
import { trackActivity } from "../../../utils/mixpanel";
const ShopvisitNavigationHeader = ({ shopVisit }) => {
  const params = useParams()
  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Shop Visit View`, page_type: page_type, })
  }
  return (
    <Paper square className="responsive-paper">
      <Grid container spacing={1} >
        <Grid item md={12} xs={12} marginTop={isMobile ? "20px" : "8px"} sx={{ display: "flex", alignItems: "center", }}>
          <Link component={RouterLink} to={`/lease/${params?.leaseSlug}/shop-visit`}
            sx={{
              display: "flex",
              alignItems: "center",
              fontFamily: "Roboto",
              textDecoration: "none",
              cursor: "pointer",
            }}
          >
            <ArrowCircleLeftOutlinedIcon />
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: "bold",
                paddingLeft: "5px",
                textDecoration: "underline",
              }}
            >
              Shop Visit
            </Typography>
          </Link>
       
          {shopVisit?.status && <Box>
            <Button
              disableRipple
              startIcon={<TaskAltIcon size="small" />}
              className="basic-details-font"
              color="primary"
              variant="outlined"
              size="small"
              onClick={() => { window.open(`/lease/${params?.leaseSlug}/lease-details/qualified-maintenance-events`, '_blank'); handleItemClicked('Qualified Maintenance Events Button') }}
              sx={{ fontSize: { xs: "7px", md: '12px' }, textTransform: 'none', mr: 1, ml: 1 }}
            >
              Qualified Maintenance Events
            </Button>
            <Button
              disableRipple
              startIcon={<TaskAltIcon size="small" />}
              className="basic-details-font"
              color="primary"
              variant="outlined"
              size="small"
              onClick={() => { window.open(`/lease/${params?.leaseSlug}/lease-details/headlines`, '_blank'); handleItemClicked('Lease Agreement Details Button') }}
              sx={{ fontSize: { xs: "7px", md: '12px' }, textTransform: 'none' }}
            >
              Lease Agreement Details
            </Button>
          </Box>}

        </Grid>
      </Grid>
    </Paper>
  )
}

export default ShopvisitNavigationHeader